// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lpXD","col":"styles_col__TAVmd","actions":"styles_actions__1CmJ4","conflict":"styles_conflict__fCbcH"};